import {
  Box,
  Button,
  Divider,
  Drawer,
  MenuItem,
  Typography,
} from '@mui/material';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useMemo, useState } from 'react';
import { eventTypesGet, eventTypeEdit, eventTypeDelete } from 'api/api';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import AddIcon from '@mui/icons-material/Add';
import { AgGridReact } from 'ag-grid-react';
import { ColDef } from 'ag-grid-community';
import { FastField, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Select, TextField } from 'formik-mui';
import React from 'react';
import moment from 'moment';
import { DesktopDatePicker } from 'formik-mui-lab';
import { eventCategories } from '../../constants';

export const EventTypes = ({
  selectedOrganization,
}: {
  selectedOrganization: any;
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [selected, setSelected] = useState<any | null>(null);

  const queryClient = useQueryClient();

  const alert = (title, message) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  /*
  const { data: getUserAdminOfOrganizationsResponse } = useQuery(
    'getUserAdminOfOrganizations',
    getUserAdminOfOrganizations,
    {
      enabled: true,
      refetchOnWindowFocus: false,
      suspense: true,
    },
  );

  const userAdminOfOrganizations = getUserAdminOfOrganizationsResponse!.data;

  const [selectedOrganizationId, setSelectedOrganizationId] = useState<number>(
    userAdminOfOrganizations[0]?.id,
  );
  */

  console.log('selected', selected);

  const {
    data: response,
    isLoading,
    error,
    refetch,
  } = useQuery(
    ['eventTypesGet', selectedOrganization?.id],
    eventTypesGet(selectedOrganization?.id as number),
    {
      enabled: !!selectedOrganization,
      refetchOnWindowFocus: false,
    },
  );
  const data: any = response?.data;

  const {
    mutateAsync,
    error: mutateError,
    data: mutateData,
    isLoading: mutateIsLoading,
  } = useMutation('eventTypeEdit', eventTypeEdit, {
    onError: (err: any) => {
      alert('Error', err.message);
    },
    onSettled: () => {
      queryClient.invalidateQueries('eventOptionsGet');
    },
  });

  const { columnDefs, rowData } = useMemo(() => {
    if (!data?.length) {
      return { rowData: [] };
    }
    const columnDefs: ColDef[] = [
      {
        field: 'name',
        headerName: 'Name',
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 2,
        minWidth: 210,
        filter: true,
      },
      {
        field: 'category',
        headerName: 'Category',
        sortable: true,
        flex: 1,
        minWidth: 80,
      },
      {
        field: 'subcategory',
        headerName: 'Subcategory',
        sortable: true,
        flex: 1,
        minWidth: 80,
      },
      {
        field: 'updatedAt',
        headerName: 'Updated at',
        sortable: true,
        flex: 1,
        minWidth: 160,
        valueFormatter: ({ data }) => {
          return moment(data.updatedAt).format('YYYY-MM-DD HH:mm');
        },
      },
    ];

    return { columnDefs, rowData: data };
  }, [data]);

  return (
    <>
      <React.Fragment key="right">
        <Drawer
          anchor="right"
          open={rightDrawerOpen}
          onClose={() => {
            refetch();
            setRightDrawerOpen(false);
          }}
        >
          <Box sx={{ width: { xs: 'calc(100vw - 16px)', sm: '600px' } }}>
            <Typography
              variant="h1"
              sx={{ fontSize: '1.3em', fontWeight: 500, m: '16px 24px' }}
            >
              {!!selected ? 'Edit event type' : 'Add event type'}
            </Typography>
            <Divider />
            <Box sx={{ padding: '24px' }}>
              <Box sx={{ mb: '20px' }}>
                <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                  Organization:{' '}
                </Typography>
                {selectedOrganization?.name}
              </Box>
              {/*
              {!!selected && (
                <Box sx={{ mb: '16px' }}>
                  <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                    User:{' '}
                  </Typography>
                  {selected?.name}
                </Box>
              )}
              */}
              {/*
              {!selected &&
                'Enter the email address of the registered user you want give permissions to the organization.'}
              */}
              <Formik
                validateOnMount
                initialValues={{
                  id: selected?.id || undefined,
                  name: selected?.name || '',
                  category: selected?.category || '',
                  subcategory: selected?.subcategory || '',
                  shortDescription: selected?.shortDescription || '',
                  description: selected?.description || '',
                  genre: selected?.genre || '',
                  openingDate: selected?.openingDate || new Date(),
                  rating: selected?.rating || '',
                  duration: selected?.duration || undefined,
                  audioLanguage: selected?.audioLanguage || '',
                  posterUrl: selected?.posterUrl || '',
                  trailerUrl: selected?.trailerUrl || '',
                }}
                validationSchema={Yup.object().shape({
                  name: Yup.string().required('Required'),
                })}
                onSubmit={async (values: any, { setSubmitting }) => {
                  values.organizationId = selectedOrganization.id;
                  try {
                    await mutateAsync({ values });
                  } catch (error: any) {
                    alert(error.error, error.message);
                  }
                  refetch();
                  setSubmitting(false);
                  setRightDrawerOpen(false);
                }}
              >
                {({
                  submitForm,
                  isSubmitting,
                  values,
                  isValid,
                  handleChange,
                  errors,
                  touched,
                  handleBlur,
                  setFieldValue,
                }) => (
                  <Form style={{ width: '100%' }}>
                    <Box
                      sx={{
                        width: '100%',
                        marginInline: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        position: 'relative',
                      }}
                    >
                      <FastField
                        component={TextField}
                        label="Name"
                        name="name"
                        size="small"
                      />
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: 1,
                          width: '100%',
                        }}
                      >
                        <Box
                          className="small-formik-select-fix"
                          sx={{ width: '50%' }}
                        >
                          <FastField
                            component={Select}
                            label="Category"
                            name="category"
                            size="small"
                          >
                            {eventCategories.map((category) => (
                              <MenuItem
                                value={category.value}
                                key={category.value}
                              >
                                {category.label}
                              </MenuItem>
                            ))}
                          </FastField>
                        </Box>
                        <FastField
                          component={TextField}
                          label="Subcategory"
                          name="subcategory"
                          size="small"
                          style={{ flexGrow: 1 }}
                        />
                      </Box>
                      <FastField
                        component={TextField}
                        label="Short description"
                        name="shortDescription"
                        size="small"
                        multiline
                        minRows={3}
                      />
                      <FastField
                        component={TextField}
                        label="Description"
                        name="description"
                        size="small"
                        multiline
                        minRows={3}
                      />

                      <FastField
                        component={TextField}
                        label="Genre"
                        name="genre"
                        size="small"
                      />
                      <Box className="small-date-picker">
                        <FastField
                          component={DesktopDatePicker}
                          label="Opening date"
                          name="openingDate"
                          size="small"
                        />
                      </Box>
                      <FastField
                        component={TextField}
                        label="Rating"
                        name="rating"
                        size="small"
                      />
                      <FastField
                        component={TextField}
                        label="Duration (minutes)"
                        name="duration"
                        size="small"
                        type="number"
                      />
                      <FastField
                        component={TextField}
                        label="Audio language"
                        name="audioLanguage"
                        size="small"
                      />
                      <FastField
                        component={TextField}
                        label="Poster URL"
                        name="posterUrl"
                        size="small"
                      />
                      <FastField
                        component={TextField}
                        label="Poster thumbnail URL"
                        name="posterThumbnailUrl"
                        size="small"
                      />
                      <FastField
                        component={TextField}
                        label="Trailer URL"
                        name="trailerUrl"
                        size="small"
                      />
                      <Box
                        sx={{
                          textAlign: 'right',
                          margin: '16px 0',
                          display: 'flex',
                          flexDirection: 'row',
                        }}
                      >
                        <Button
                          color="primary"
                          disabled={isSubmitting}
                          onClick={() => setRightDrawerOpen(false)}
                          sx={{ padding: '6px 8px' }}
                        >
                          Cancel
                        </Button>

                        <Box sx={{ flex: '1 1 auto' }} />
                        {!!selected && (
                          <Button
                            color="primary"
                            disabled={isSubmitting}
                            onClick={() => setDialogOpen(true)}
                            sx={{ padding: '6px 8px' }}
                          >
                            Delete
                          </Button>
                        )}
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Button
                          color="primary"
                          variant="contained"
                          disabled={isSubmitting || !isValid}
                          sx={{ padding: '6px 24px' }}
                          onClick={submitForm}
                        >
                          {!!selected ? 'Save' : 'Add'}
                        </Button>
                      </Box>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        </Drawer>
      </React.Fragment>
      <Dialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`${alertTitle}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`${alertMessage}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Deletion confirmation'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to delete this? The event type will not be deleted if it is in a event type set.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              try {
                const response = await eventTypeDelete(selected.id)();
                setDialogOpen(false);
                if (response) {
                  refetch();
                  setDialogOpen(false);
                  setRightDrawerOpen(false);
                }
              } catch (error: any) {
                refetch();
                setDialogOpen(false);
                setRightDrawerOpen(false);
                alert(error.error, error.message);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: '1',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexGrow: 0,
            alignItems: 'center',
            gap: 1,
            height: '56px',
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontSize: '1.25rem',
            }}
          >
            Event types
          </Typography>
          <Button
            color="primary"
            onClick={() => {
              setSelected(null);
              setRightDrawerOpen(true);
            }}
          >
            <AddIcon sx={{ ml: -0.5, mr: 0.5 }} />
            Add new
          </Button>
        </Box>
        <Box
          className="ag-theme-material"
          sx={{
            background: '#000',
            borderRadius: 0,
            margin: '0 -16px -16px',
            display: 'flex',
            overflow: 'hidden',
            flexGrow: 1,
            height: '100%',
            boxShadow:
              'rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px',
          }}
        >
          <AgGridReact
            className="ag-pointer-row"
            rowData={rowData}
            pagination={true}
            floatingFiltersHeight={50}
            paginationAutoPageSize={true}
            columnDefs={columnDefs}
            onRowClicked={({ data }) => {
              setSelected(data);
              setRightDrawerOpen(true);
            }}
          ></AgGridReact>
        </Box>
      </Box>
    </>
  );
};
